const initState = {
	searchData: {}, // Search results.
	listingData: {}, // Base article listings.
	isLoading: true, // Are we loading data?
	activeResults: [], // Array of objects.
	isSearch: false, // Are we showing listings or searching.
	activeType: 'course', // The type selected in the search form.
	activeTerm: '',
};

const everythingReducer = (state = initState, action) => {
	switch (action.type) {
		case 'SET_LISTING_DATA':
			return {
				...state,
				isLoading: false,
				isSearch: false,
				listingData: action.payload.data,
				activeResults: action.payload.activeResults,
			};

		case 'SET_SEARCH_DATA':
			return {
				...state,
				activeTerm: action.payload.activeSearchTerm,
				isLoading: false,
				isSearch: true,
				searchData: action.payload.data,
				activeResults: action.payload.activeResults,
			};
		case 'SET_LOADING':
			return {
				...state,
				isLoading: true,
			};
		default:
			return { ...state };
	}
};

export default everythingReducer;
